import {Button, Card, DatePicker, Form, Input, message, Popconfirm, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/SubList";
import UploadFile from "../../components/UploadFile";
import MasterModal from "../../components/MasterModal";
import * as moment from 'moment';

class Create extends React.Component {
  // state = {
  //   documentType: null,
  //   checkedForInsuranceAmount: false,
  //   amount: null,
  // };
  constructor(props) {
    super(props);
    this.state = {
      documentType: null,
      checkedForInsuranceAmount: false,
      amount: null,
    };
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match && match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.data !== this.props.data) {
      console.log(nextProps.data);
      this.setState({documentType: nextProps.data.type})
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      // console.log(values);
      const docTypes = (this.props.filters['type'].data.data || []).filter(dt => dt._id === values.type);
      values.docType = docTypes [0];
      if(match && match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
        this.props.form.resetFields();
      }
    });
  };

  deleteCompleteDocument = () => {
    const {match} = this.props;
    if(match && match.params && match.params.id) {
      this.props.deleteResource(match.params.id);
    }
  }

  onTypeChange = value => {
    const {filters} = this.props;
    const documentType = filters['type'] && filters['type'].data && filters['type'].data.data && filters['type'].data.data.find(ele => ele._id === value);

    if(documentType && documentType.isAmountCheckedRequired) {
      this.setState({checkedForInsuranceAmount: true});
    } else {
      this.setState({checkedForInsuranceAmount: false});
    }
    this.setState({documentType});
  };

  cancelDelete = () => {
    message.error('Cancelled');
  }

  render() {
    const {documentType} = this.state;
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {

              if(filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title}
                                resource={resource}/>
              } else if(filters[item].field.includes('file.')) {
                return null
              } else {
                if(item === 'type') {
                  return <>
                    <Form.Item key={item}
                               label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                      {getFieldDecorator(item, {
                        rules: [{
                          required: filters[item].required,
                          message: `${filters[item].options.label ? filters[item].options.label : item} is required!`
                        }],
                        initialValue: data && data[item] && (data[item]._id || data[item]),
                      })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        style={(filters[item].options.master || filters[item].options.superMaster) ? {
                          width: '80%',
                          marginTop: '-10px'
                        } : {width: '100%'}}
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder="Please select"
                        onSelect={this.onTypeChange}
                        onChange={this.onTypeChange}
                      >
                        {filters[item] && filters[item].data && filters[item].data.data && filters[item].data.data.map(item =>
                          <Select.Option key={item._id}
                                         value={item._id}>{item.name}</Select.Option>)}
                      </Select>)
                      }
                      {
                        filters[item] && filters[item].options && filters[item].options.master ?
                          <MasterModal subMaster={this.props.subMaster || false} resource={resource}
                                       item={filters[item].options.ref} title={'CREATE'}/> : ''
                      }
                    </Form.Item>

                    {this.state.checkedForInsuranceAmount === true || (data && data.type && data.type.isAmountCheckedRequired) ?
                      <Form.Item key={'amount'} label={'Amount'}>
                        {getFieldDecorator('amount', {
                          rules: [{
                            required: (documentType && documentType.isAmountCheckedRequired) || filters[item].required,
                            message: `amount is required!`
                          }],
                          initialValue: data && data.amount,
                        })(<Input
                          onWheel={event => event.currentTarget.blur()}
                          style={{width: '80%'}} type="number"/>)
                        }
                      </Form.Item> : null
                    }
                  </>
                }
                else if(item === 'documentDate') {
                  return <Form.Item key={item}
                                    label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: (documentType && documentType.isDocumentDateRequired) || filters[item].required,
                        message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
                      }],
                      initialValue: data && data[item] && moment(data[item]),
                    })(<DatePicker/>)
                    }
                  </Form.Item>
                }
                else if(item === 'renewalDate') {
                  return <Form.Item key={item}
                                    label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: (documentType && documentType.isRenewalDateRequired) || filters[item].required,
                        message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
                      }],
                      initialValue: data && data[item] && moment(data[item]),
                    })(<DatePicker/>)
                    }
                  </Form.Item>
                } else
                  return getFormFieldByType(filters, item, getFieldDecorator, data, {resource})
              }
            })}

            <UploadFile form={form} data={data} showUploadList={this.props.visible}/>

            <div key={'btn'} style={{display: "flex", justifyContent: 'left',}}>
              <Form.Item key='saveBtn'>
                <Button type="primary"
                        className="gx-mb-0"
                        htmlType="submit"
                        loading={loading}
                        disabled={this.props.isDisabled}>
                  {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button>
              </Form.Item>
              {this.props.title === "EDIT" ?
                <Popconfirm
                  title="Are you sure you want to delete this record ?"
                  onConfirm={this.deleteCompleteDocument}
                  disabled={this.props.isDisabled}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger"
                          className="gx-mb-0"
                          loading={loading}
                          style={{marginLeft: '10px', marginTop: '15px'}}
                  >Delete</Button>
                </Popconfirm>
                : ''
              }
            </div>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'document_create',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
